export const errorElementsSelector: { [key: string]: string } = {
  selectedEPS_Root: '.formik-error-selectedEPS_Root',
  selectedEPS_Remuneration: '.formik-error-selectedEPS_Remuneration',
  grid: '.MuiGrid-root.MuiGrid-container',
};
